import { render, staticRenderFns } from "./ScopeProvider.vue?vue&type=template&id=23265163&"
import script from "./ScopeProvider.vue?vue&type=script&lang=js&"
export * from "./ScopeProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports